module.exports = __webpack_public_path__ + "img/centerPoint.93104154.svg";